document.addEventListener('DOMContentLoaded', function () {

    const stickyBar = document.querySelector('.mm-sticky-bar');
    const sectionId = stickyBar.id.replace('mm-sticky-bar-', '');

    const buyButtonsSection = document.querySelector(
        '[data-section-id="' + sectionId + '"] .product-form__buttons'
    );
    const productInfo = document.getElementById('ProductInfo-' + sectionId);

    if (!stickyBar || !buyButtonsSection) return;

    let isVisible = false;
    let ticking = false;

    function updateStickyBarVisibility() {
        const rect = buyButtonsSection.getBoundingClientRect();
        const shouldShow = rect.bottom < window.innerHeight * 0.8;

        if (shouldShow && !isVisible) {
            stickyBar.classList.add('show');
            isVisible = true;
        } else if (!shouldShow && isVisible) {
            stickyBar.classList.remove('show');
            isVisible = false;
        }
        ticking = false;
    }

    function requestTick() {
        if (!ticking) {
            requestAnimationFrame(updateStickyBarVisibility);
            ticking = true;
        }
    }

    // Listen for scroll events
    window.addEventListener('scroll', requestTick);
    window.addEventListener('resize', requestTick);

    // Initial check
    updateStickyBarVisibility();

    // Handle smooth scrolling for navigation links
    const stickyLinks = stickyBar.querySelectorAll('.mm-sticky-link');
    stickyLinks.forEach(function (link) {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                // Calculate offset to account for sticky bar height
                const stickyBarHeight = stickyBar.offsetHeight;
                const targetOffset = targetElement.offsetTop - stickyBarHeight - 20; // 20px extra padding

                window.scrollTo({
                    top: targetOffset,
                    behavior: 'smooth',
                });
            }
        });
    });

    // Handle sticky buy button click by triggering main form submission
    const stickyButton = stickyBar.querySelector('.mm-sticky-buy-button');
    const mainForm = document.querySelector(
        '[data-section-id="' + sectionId + '"] form[action*="/cart/add"]'
    );
    let mainSubmitButton = document.querySelector('button[dpo_add2cart="1"]');

    const btnObserver = new MutationObserver((mutations, obs) => {
        const buttons = document.querySelectorAll('button[name="add"]');
        if (buttons.length > 1) {
            // Do your logic here
            mainSubmitButton = buttons[1];

            if (stickyButton && mainForm) {
                stickyButton.addEventListener('click', function (e) {
                    e.preventDefault();

                    // Trigger the main form submission
                    if (mainSubmitButton) {
                        mainSubmitButton.click();
                    } else {
                        // Fallback: submit the form directly
                        mainForm.submit();
                    }
                });
            }
            obs.disconnect(); // Stop watching once found
        }
    });

    btnObserver.observe(document.body, { childList: true, subtree: true });

    // Target the visible button specifically

    // Sync button state with main form
    const mainVariantInput = document.querySelector(
        '[data-section-id="' + sectionId + '"] .product-variant-id'
    );

    if (mainVariantInput && stickyButton) {
        // Watch for variant changes in main form to update sticky button state
        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (
                    mutation.type === 'attributes' &&
                    (mutation.attributeName === 'value' ||
                        mutation.attributeName === 'disabled')
                ) {
                    updateStickyButtonState();
                }
            });
        });

        observer.observe(mainVariantInput, {
            attributes: true,
            attributeFilter: ['value', 'disabled'],
        });

        // Also watch the main submit button for state changes
        if (mainSubmitButton) {
            const mainButtonObserver = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    if (
                        mutation.type === 'attributes' &&
                        mutation.attributeName === 'disabled'
                    ) {
                        updateStickyButtonState();
                    }
                });
            });

            mainButtonObserver.observe(mainSubmitButton, {
                attributes: true,
                attributeFilter: ['disabled'],
            });
        }

        // Function to update sticky button state based on main form
        function updateStickyButtonState() {
            const isMainButtonDisabled = mainSubmitButton
                ? mainSubmitButton.disabled
                : mainVariantInput.disabled;
            const mainButtonText = mainSubmitButton
                ? mainSubmitButton.querySelector('span')
                : null;
            const stickyButtonText = stickyButton.querySelector('span');

            stickyButton.disabled = isMainButtonDisabled;

            if (stickyButtonText && mainButtonText) {
                stickyButtonText.textContent = mainButtonText.textContent;
            }
        }

        // Initial sync
        updateStickyButtonState();
    }

    // Listen for variant change events to update sticky bar price
    document.addEventListener('variant:change', function (event) {
        if (event.detail && event.detail.variant) {
            const stickyPriceElement = stickyBar.querySelector('.mm-sticky-bar__price .price');
            const mainPriceElement = document.querySelector('#price-' + sectionId + ' .price');

            if (stickyPriceElement && mainPriceElement) {
                // Clone the updated price from main section
                stickyPriceElement.innerHTML = mainPriceElement.innerHTML;
            }
        }
    });

    // Also listen for general price updates
    const priceObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.type === 'childList' || mutation.type === 'characterData') {
                const stickyPriceElement = stickyBar.querySelector(
                    '.mm-sticky-bar__price .price'
                );
                const mainPriceElement = document.querySelector(
                    '#price-' + sectionId + ' .price'
                );

                if (
                    stickyPriceElement &&
                    mainPriceElement &&
                    stickyPriceElement.innerHTML !== mainPriceElement.innerHTML
                ) {
                    stickyPriceElement.innerHTML = mainPriceElement.innerHTML;
                }
            }
        });
    });

    const mainPriceContainer = document.querySelector('#price-' + sectionId);
    if (mainPriceContainer) {
        priceObserver.observe(mainPriceContainer, {
            childList: true,
            subtree: true,
            characterData: true,
        });
    }
});